import "../../styles/legacy-css/LoginPopup.css";
import { useLoginStageContext } from "../../contexts/LoginStageContext";
import React, { SetStateAction, useState } from "react";
import UserPool from "../../services/aws/UserPool";
import { CognitoUser } from "amazon-cognito-identity-js";
import { StyledPopupErrorList, StyledPopupForm } from "../../styles/components/Popup.styled";
import {Button} from "../../styles/components/Buttons.styled";

function ForgotPasswordPopup() {
  const { setLoginStage, setLoginMessage } = useLoginStageContext();
  return (
    <div className="login-popup">
      <div className="login-popup-inner">
        <button
          className="close-btn"
          aria-label="Close"
          onClick={() => {
            setLoginMessage(null);
            setLoginStage("none");
          }}
        >
          &times;
        </button>
        <ForgorPassword />
      </div>
    </div>
  );
}

function ForgorPassword() {
  const [email, setEmail] = useState("");
  const [stage, setStage] = useState<1 | 2>(1);

  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { setLoginStage, setLoginMessage } = useLoginStageContext();
  const [errorMessage, setErrorMessage] = useState("");

  const getUser = () => {
    return new CognitoUser({
      Username: email.toLocaleLowerCase(),
      Pool: UserPool,
    });
  };

  const sendCode = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    getUser().forgotPassword({
      onSuccess: (data) => {setErrorMessage("")},
      onFailure: (err) => {setErrorMessage("ERROR: Unable to send varification code. Please check the email address.")},
      inputVerificationCode: (data) => {
        setStage(2);
      },
    });
  };

  const resetPassword = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      setErrorMessage("Passwords must match");
      return;
    }

    getUser().confirmPassword(code, password, {
      onSuccess: (data) => {
        setLoginMessage("Password Successfully Reset");
        setLoginStage("login");
      },
      onFailure: (err) => {
        if (err.name == "InvalidParameterException") {
          setErrorMessage("Password issue");
        } else {
          setErrorMessage("Issue Setting Password");
        }
      },
    });
  };

  function changeStage(value:SetStateAction<1|2>){
    setErrorMessage("")
    setStage(value);
  }

  return (
    <>
      {stage === 1 && (
        <StyledPopupForm onSubmit={sendCode}>
          <h1>Reset Password</h1>
          <label>Email: </label>
          <input
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          {errorMessage != "" && <StyledPopupErrorList><li>ERROR: {errorMessage}</li></StyledPopupErrorList>}
          <div>
            <Button type="submit">Send Code</Button>
          </div>
        </StyledPopupForm>
      )}

      {stage === 2 && (
        <StyledPopupForm onSubmit={resetPassword}>
          <h1>Update Password</h1>
          <label>Code</label>
          <input
            value={code}
            onChange={(event) => setCode(event.target.value)}
          />
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          <label>Confirm Password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
          />
          {email != "" && (
            <div>
              An email was sent to <b>{email}</b> with a verification code.
            </div>
          )}
          {errorMessage != "" && <StyledPopupErrorList><li>ERROR: {errorMessage}</li></StyledPopupErrorList>}
          <div>
            <Button type="submit">Reset Password</Button>
            <Button type="button" onClick={() => changeStage(1)}>
              Send New Code
            </Button>
          </div>
        </StyledPopupForm>
      )}

      <hr
        style={{
          margin: "20px 0",
          border: "none",
          borderTop: "1px solid rgba(255, 255, 255, 0.4)",
        }}
      />

      {stage === 1 && (
        <div style={{ marginBottom: "10px" }}>
          Already have a code? Enter it{" "}
          <a
            href="#"
            style={{ color: "#ffffff", fontWeight: 700, textDecoration: "underline" }}
            onClick={(e) => {
              e.preventDefault();
              changeStage(2);
            }}
          >
            here
          </a>
          .
        </div>
      )}

      <div>
        Remembered your password? Sign in{" "}
        <a
          href="#"
          style={{ color: "#ffffff", fontWeight: 700, textDecoration: "underline" }}
          onClick={(e) => {
            e.preventDefault();
            setLoginStage("login");
          }}
        >
          here
        </a>
        .
      </div>
    </>
  );
}

export default ForgotPasswordPopup;
